import React from "react";
import { Modal } from "../../components/ui";
import UserDetailPanel from "./UserDetailPanel.jsx";
import "./user-detail-drawer.scss";

const PROFILE_TITLE = {
  client: "Client profile",
  merchant: "Merchant profile",
  expert: "Expert profile",
  concierge: "Expert profile",
  personal_shopper: "Merchant profile",
  supplier: "Merchant profile",
  watchmaker: "Merchant profile",
};

/**
 * User profile drawer — Fontaine M55B. The M31 Modal owns the chrome
 * (right drawer on laptop, bottom sheet on phones, scrim, Escape, focus
 * trap, scroll lock, focus return). The `users-dark` class on the modal
 * root carries the legacy RC-dark form theming into the portal — the tab
 * bodies' `.users-dark .cdr__content …` rules live in
 * src/styles/_users-dark-theme.scss and need that ancestor.
 *
 * ponytail: M55B is the drawer + panel chrome only. The tab BODIES
 * (OverviewTab/KycTab/Notes/Activity/Requests/Orders) are the inherited
 * legacy surfaces — including OverviewForm's Save/Invite command row, kept
 * as buttons because moving that form to auto-save changes its API write
 * model, which this milestone must not touch. Upgrade path: a dedicated
 * form-migration milestone on Field + useAutosave.
 */
const UserDetailDrawer = ({ open, contact, onClose, onContactUpdated }) => {
  if (!contact) return null;

  return (
    <Modal
      open={open}
      onClose={onClose}
      variant="drawer"
      size="lg"
      // No visible heading: "Client profile" restated what the panel's own hero — avatar, name,
      // status badge — already says, and cost a whole row at the top of the panel. It stays as
      // the dialog's ACCESSIBLE name, which Modal falls back to when `title` is absent, so a
      // screen reader still announces what opened. The close button keeps its row.
      aria-label={PROFILE_TITLE[contact.type] || "User profile"}
      className="users-dark users-profile-drawer"
    >
      <UserDetailPanel contact={contact} onContactUpdated={onContactUpdated} />
    </Modal>
  );
};

export default UserDetailDrawer;
